import {ServerGridModalV3} from "../../../../helpers/modals/ClassBased/ServerGridModalV3";
import {createGrid} from "../../../../helpers/grids/grids";
import {createCellRenderer, createDoubleClickHandler} from "../../../../helpers/grids/helpers";
import createElement from "../../../../helpers/createElement";
import {getSingleInputElementByNameV3} from "../../../../helpers/forms/formInputsHelpers";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts file
class PickAuditionRequestModal extends ServerGridModalV3 {
	/** @var {import('../../grids/grids').GridInstance} */
	gridInstance;
	/** @var {PickAuditionRequestModalDefs.Config} */
	config;

	/** @var {HTMLSelectElement} */
	forRoleSelect;

	initGridView() {
		// noinspection JSValidateTypes
		this.forRoleSelect = getSingleInputElementByNameV3(this.modalContainer, 'role');

		// Init grid
		this.gridInstance = createGrid(
			this.getGridContainer(),
			{
				columnDefs: [
					{
						field: "public_id",
						headerName: '',
						maxWidth: 80,
						cellClass: 'fill-space',
						cellRenderer: createCellRenderer(params => {
							return this.getPhotoCellElement(params.data);
						})
					},
					{
						field: "full_name",
						headerName: 'Name',
						sortable: true,
						sort: 'asc',
						cellRenderer: createCellRenderer(params => {
							// noinspection JSUnresolvedReference
							return `<div class="font-weight-bold">${params.data.full_name}</div>`;
						})
					},
					{
						field: "public_id",
						headerName: '',
						maxWidth: 80,
						cellClass: 'fill-space',
						cellRenderer: createCellRenderer(params => {
							// noinspection JSUnresolvedVariable
							const buttons = createElement(`
								<div class="buttons h-100 d-flex justify-content-center align-items-center">
									<button class="btn btn-primary select-button">
										Select
									</button>
								</div>`
							)

							const selectButton = buttons.querySelector('.select-button');

							if (selectButton) {
								selectButton.addEventListener('click', () => {
									this.handleSelectRequest(params.data);
								})
							}

							return buttons;
						})
					},
					{
						field: 'roles_string',
						headerName: 'Auditioned For',
						wrapText: true,
						sortable: false,
						maxWidth: 300,
						cellRenderer: createCellRenderer(params => {
							// noinspection JSUnresolvedReference
							return `<div class="small text-wrap py-1" style="line-height: 1" title="Requested Roles">${params.data.roles_string}</div>`;
						}),
					},
					{
						field: 'is_virtual_audition',
						headerName: 'Virtual Audition',
						sortable: true,
						cellRenderer: createCellRenderer(params => {
							// noinspection JSUnresolvedReference
							return params.data.is_virtual_audition ? 'Yes' : 'No';
						})
					},

				],
				rowClass: 'cursor-pointer',
				getRowHeight: (params) => {
					const minHeight = 110;

					const lineHeightInPixels = 14;
					const charsPerLine = 52
					// noinspection JSUnresolvedReference
					const rolesCellEstimatedHeight = Math.ceil(params.data.roles_string.length / charsPerLine) * lineHeightInPixels

					// Return either roles cell estimated height or the min height
					return (rolesCellEstimatedHeight < minHeight) ? minHeight : rolesCellEstimatedHeight;
				},
				_rowName: 'Actors',
				onCellDoubleClicked: createDoubleClickHandler(actor => {
					// noinspection JSCheckFunctionSignatures
					this.handleSelectRequest(actor);
				})
			},
			this.getGridRoute(),
			() => {
				const filters = {};

				if (this.forRoleSelect) {
					filters.role = this.forRoleSelect.value;
				}

				return filters
			}
		)

		if (this.forRoleSelect) {
			this.forRoleSelect.addEventListener('change', () => {
				this.gridInstance._refresh();
			})
		}
	}

	/**
	 * @param {PickAuditionRequestModalDefs.AuditionRequestActor} selectedActor
	 */
	handleSelectRequest(selectedActor) {
		if (this.config.onActorSelect) {
			this.config.onActorSelect(selectedActor);
		}
	}

	/**
	 * @param {PickAuditionRequestModalDefs.AuditionRequestActor} actor
	 */
	getPhotoCellElement(actor) {
		// noinspection HtmlRequiredAltAttribute
		const html = `
			<div class="photo-cell h-100 d-flex justify-content-center align-items-center">
				<div class="position-relative" style="width: 60px; height: 80px">
					<div class="photo-wrapper border">
						${actor.photo ? `<img src="${actor.photo}" loading="lazy">` : `<div class="text-muted text-center no-photo-message">No<br>Photo</div>`}
					</div>
				</div>
			</div>
		`;

		return createElement(html);
	}
}

export {PickAuditionRequestModal}
